import axios from "axios";

function permissionsListMapper(permissions) {
  return Object.keys(permissions).map((p) => ({
    key: p,
    value: permissions[p],
    label: p,
  }));
}

function mapAgents({ agents }) {
  return agents.map((agent) => ({
    id: agent.agentId,
    firstName: agent.firstName,
    lastName: agent.lastName,
    email: agent.email,
    roles: agent.roles,
    status: agent.status,
    avatar: agent.avatar ? `https://dgk28ckagqims.cloudfront.net/avatars/${agent.avatar}` : null,
    permissions: [],
    isMfaEnabled: agent.mfaEnabled,
    isEmailVerified: agent.isEmailVerified,
    mfaForced: agent.forced,
    isLoading: false,
  }));
}

export default {
  fetchAgents({ commit, rootGetters }) {
    commit("loading", true);
    axios
      .get("/json/settings/agents/list")
      .then(({ data: { agents } }) => {
        commit(
          "agents",
          mapAgents({
            agents,
          })
        );
      })
      .catch(() => {
        commit("error", true);
      })
      .finally(() => {
        commit("loading", false);
      });
  },
  fetchPermissionsPresets({ commit }) {
    axios.get("/account/permissions/presets").then(({ data: presets }) => {
      commit("updatePermissionsPresets", presets);
    });
  },
  fetchAgentPermissions({ state, commit, getters }, { id }) {
    const agent = getters.agentById(id);
    if (agent.permissions.length > 0) {
      return false;
    }
    commit("updateAgentPermissionsLoader", { id, isLoading: true });

    axios
      .get(`/account/permissions/agent?agent_id=${id}`)
      .then(({ data: permissions }) => {
        commit("setAgentPermissions", {
          id,
          permissions: permissionsListMapper(permissions),
        });
      })
      .finally(() => {
        commit("updateAgentPermissionsLoader", { id, isLoading: false });
      });
  },
  addAgent({ state, commit }) {
    axios
      .post("/settings/add_agent", {
        firstname: state.newAgentForm.firstName,
        lastname: state.newAgentForm.lastName,
        email: state.newAgentForm.email,
      })
      .then(({ data: { id, status } }) => {
        if (status === "success") {
          commit("addNewAgent", id);
          commit("resetNewAgentForm");
        } else if (status === "exist") {
          window.window.showToast("Agent already exists", "error");
        }
      })
      .catch((error) => {
        if (error.response.status === 422) {
          window.window.showToast("Invalid fields: " + error.response.data.invalidFields.join(","), "error");
        } else {
          window.window.showToast("An error occurred", "error");
        }
      });
  },
  applyPermissionsPreset({ state, commit, getters, dispatch }, { id, presetKey }) {
    const agent = getters.agentById(id);
    const presetPermissions = permissionsListMapper(state.permissionsPresets[presetKey]);

    const permissionsFromAgent = ["ROLE_AGENT", "ROLE_SUPER_AGENT"];

    const permissions = [
      ...presetPermissions.filter((p) => !permissionsFromAgent.includes(p.key)),
      ...permissionsFromAgent.map((p) => {
        const agentPerm = agent.permissions.find((perm) => perm.key === p);
        return {
          key: p,
          value: Boolean(agentPerm) ? agentPerm.value : false,
          label: p,
        };
      }),
    ];

    commit("setAgentPermissions", {
      id,
      permissions: permissions,
    });
    dispatch("saveAgentPermissions", { id });
  },
  saveAgentPermissions({ state, getters }, { id }) {
    const permissionsList = getters
      .agentPermissions(id)
      .filter((p) => p.value)
      .map((p) => p.key);
    if (!permissionsList.includes("ROLE_AGENT") && !permissionsList.includes("ROLE_SUPER_AGENT")) {
      permissionsList.push("ROLE_AGENT");
    }
    axios
      .post(`/account/permissions/agent/${id}`, {
        roles: permissionsList,
      })
      .then(({ data: { status } }) => {
        if (status === "failed") {
          window.window.showToast("An error occurred", "error");
        } else {
          window.window.showToast(window.$_t("Saved"), "success");
        }
      })
      .catch(() => {
        window.window.showToast("An error occurred", "error");
      });
  },
  resendInvitation({}, id) {
    axios
      .post("/settings/resend_token", {
        invited_agent_id: id,
      })
      .then(() => {
        window.window.showToast(window.$_t("Invitation sent"), "success");
      })
      .catch(() => {
        window.showToast("An error occurred", "error");
      });
  },
  deleteAgent({ state, commit }, id) {
    axios
      .post("/settings/delete_agent", {
        agent_id: id,
      })
      .then(() => {
        window.window.showToast(window.$_t("Saved"), "success");
        commit("removeAgent", id);
      })
      .catch(() => {
        window.showToast("An error occurred", "error");
      });
  },
  updateAgentDetails({ commit, getters }, { id, firstName, lastName }) {
    axios
      .post("/settings/agents/updateName", {
        firstname: firstName,
        lastname: lastName,
        agent_id: id,
      })
      .then(() => {
        commit("updateAgentDetails", { id, firstName, lastName });
        window.window.showToast(window.$_t("Saved"), "success");
      })
      .catch(() => {
        window.window.showToast("There was an error", "error");
      });
  },
  promoteToSuperagent({ commit, getters }, { id }) {
    let permissionsList = getters
      .agentPermissions(id)
      .filter((p) => p.value)
      .map((p) => p.key);
    if (permissionsList.indexOf("ROLE_AGENT") !== -1) {
      permissionsList.splice(permissionsList.indexOf("ROLE_AGENT"), 1);
    }
    permissionsList.push("ROLE_SUPER_AGENT");
    axios
      .post(`/account/permissions/agent/${id}`, {
        roles: permissionsList,
      })
      .then(() => {
        commit("setAgentPermissions", { id, permissions: permissionsList });
        window.window.showToast(window.$_t("Saved"), "success");
      })
      .catch((e) => {
        console.log(e);
        window.window.showToast("There was an error", "error");
      });
  },
};
